export function getStreamDay(fromTime, time, utc = true) {
    const resetTime = (time) => {
        let d = new Date(time * 1000);
        if (utc) {
            d.setUTCMilliseconds(0);
            d.setUTCSeconds(0);
            d.setUTCMinutes(0);
            d.setUTCHours(0);
        } else {
            d.setMilliseconds(0);
            d.setSeconds(0);
            d.setMinutes(0);
            d.setHours(0);
        }
        return Math.floor(d.getTime() / 1000);
    }
    const diffSeconds = resetTime(time) - resetTime(fromTime);
    if (diffSeconds < 0) {
        return null;
    }
    return Math.floor(diffSeconds / 3600 / 24);
}
